import React, { useEffect, useState } from 'react';
import { Link } from '@ambiguous/link';
import qProjects from '@assets/gql/projects.gql';
import qAttributes from '@assets/gql/projects.attributes.gql';
import { Filters } from '@assets/tsx/list';
import SidebarModal, { SidebarControllers } from "@assets/tsx/sidebarModal/SidebarModal";
import ActiveFilters from '@assets/tsx/activeFilters/ActiveFilters';
import { useQuery } from '@apollo/client';
import client from '@gql/client';
import { PaginatorButtons } from '@assets/tsx/paginator/buttons';
import OutsideAlerter from '@assets/tsx/outsideClicker';
import { LoadingBox } from '@assets/tsx/loadingBox/loadingBox';
import { useListContext } from '@assets/spa/context/list';
import { useRouterPath } from '@ambiguous/useRouterPath';
import { useLang } from '@ambiguous/useLang';
import { useI18n } from '@wordpress/react-i18n';
const PER_PAGE = 10;
export default function Projects({ _id, categories, attributes, show_empty, title }) {
    const [lists, setLists] = useListContext();
    const listData = lists ? (lists[_id] || {}) : {};
    const [path] = useRouterPath();
    const [checkedFilters, setCheckedFilters] = useState((listData === null || listData === void 0 ? void 0 : listData.checkedFilters) || []);
    const [wrap, setWrap] = useState();
    const [toggleMenu, setToggleMenu] = useState(false);
    const [page, setPage] = useState((listData === null || listData === void 0 ? void 0 : listData.page) || 0);
    useEffect(() => {
        setLists && setLists((prev) => (Object.assign(Object.assign({}, prev), { [_id]: { path, checkedFilters, page } })));
    }, [page, checkedFilters]);
    const openMenu = () => {
        setToggleMenu(true);
    };
    const closeMenu = () => {
        setToggleMenu(false);
    };
    const clearFilters = () => {
        setCheckedFilters([]);
    };
    const { filters, attrData } = useFilters((attributes === null || attributes === void 0 ? void 0 : attributes.checked) || [], (attributes === null || attributes === void 0 ? void 0 : attributes.hidden) || [], show_empty);
    const { items, loading, total, fetchMore, } = useProjectList(categories, attrData, checkedFilters, page, setPage);
    const hasFilters = filters && Object.keys(filters).length > 0;
    return (React.createElement(React.Fragment, null,
        React.createElement(ActiveFilters, { visible: hasFilters, setCheckedFilters: setCheckedFilters, labels: attrData, filters: checkedFilters, toggleMenu: () => {
                openMenu();
            } }),
        React.createElement("div", { className: "ltg-list ltg-list-projects", style: { gridTemplateColumns: hasFilters ? '300px 1fr' : '1fr' }, ref: setWrap },
            React.createElement("div", { className: "ltg-list-filters" },
                React.createElement("div", { className: 'ltg-list-filters-desktop' }, hasFilters && React.createElement(Filters, { checkedFilters: checkedFilters, setCheckedFilters: setCheckedFilters, filters: filters }))),
            React.createElement("div", { className: "ltg-list-wrap" },
                title && (React.createElement("h2", { className: "ltg-list-wrap-heading", role: 'presentation' }, title)),
                React.createElement(ItemList, { items: loading ? new Array(PER_PAGE).fill('loading') : items, loading: loading || !(attrData === null || attrData === void 0 ? void 0 : attrData.terms) }),
                filters && Object.keys(filters).length > 0 &&
                    React.createElement(SidebarModal, { type: 'mobile', open: toggleMenu },
                        React.createElement(OutsideAlerter, { className: 'ltg-modal-sidebar-wrap', callback: () => {
                                setToggleMenu(false);
                            } },
                            React.createElement(SidebarControllers, { isFilters: true, handleCloseMenu: () => {
                                    closeMenu();
                                }, handleClearFilters: () => {
                                    clearFilters();
                                } }),
                            React.createElement("div", { className: '.ltg_wrapper_visible_on_mobile' }, filters && Object.keys(filters).length > 0 &&
                                React.createElement(Filters, { checkedFilters: checkedFilters, setCheckedFilters: setCheckedFilters, filters: filters, setPage: setPage })))),
                total > 1 &&
                    (React.createElement("div", { className: "ltg-posts-paginator-wrap" },
                        React.createElement(PaginatorButtons, { page: page, total: total, onClick: (clickedPage) => {
                                setPage(clickedPage);
                                fetchMore(clickedPage).then(() => {
                                    wrap && wrap.scrollIntoView();
                                });
                            } })))))));
}
;
const ItemList = (props) => {
    const { items, loading } = props;
    const { __ } = useI18n();
    // if(loading) return <h2 role={'presentation'}>Kraunasi</h2>
    if (!loading && !(items === null || items === void 0 ? void 0 : items.length))
        return React.createElement("h1", { role: 'presentation', className: "text-center" }, __("Įrašų nėra", 'ltg-widgets'));
    return (React.createElement(React.Fragment, null, items && items.map(({ title, uri, projektuKategorijos, id }, index) => {
        if (loading) {
            return React.createElement(LoadingBox, { key: `project-loader-${index}`, style: { height: 85, marginBottom: 16 } });
        }
        return (React.createElement(React.Fragment, { key: id },
            React.createElement(ListItem, { title: title, uri: uri, categories: projektuKategorijos.nodes })));
    })));
};
function useProjectList(categories, attrData, checkedFilters, page, setPage) {
    var _a, _b, _c;
    const [lang] = useLang();
    let taxArray = [];
    if (categories && categories.length !== 0) {
        taxArray.push({ field: 'TAXONOMY_ID', operator: 'IN', taxonomy: 'PROJEKTUKATEGORIJA', terms: categories });
    }
    if (attrData === null || attrData === void 0 ? void 0 : attrData.terms) {
        const checkedArr = attrData.terms.nodes.filter(f => checkedFilters.includes(f.databaseId));
        const filterMap = {};
        for (const attribute of checkedArr) {
            const { taxonomyEnumValue, databaseId } = attribute;
            if (!filterMap[taxonomyEnumValue]) {
                filterMap[taxonomyEnumValue] = [];
            }
            filterMap[taxonomyEnumValue].push(databaseId.toString());
        }
        const filterVar = Object.keys(filterMap).reduce((agr, fenum) => [...agr, { taxonomy: fenum, terms: filterMap[fenum], field: 'ID', operator: 'IN' }], []);
        if (filterVar.length !== 0) {
            taxArray = taxArray.concat(filterVar);
        }
    }
    const perPage = PER_PAGE;
    const { data, loading, fetchMore, refetch } = useQuery(qProjects, {
        client,
        variables: {
            taxArray: taxArray.length === 0 ? undefined : taxArray,
            perPage,
            offset: perPage * page,
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        },
        skip: !attrData
    });
    const fetchMoreItems = (page) => new Promise((res, rej) => {
        setPage(page);
        refetch({
            taxArray: taxArray.length === 0 ? undefined : taxArray,
            perPage,
            offset: perPage * page,
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        }).then(res).catch(err => { rej(err); });
    });
    const total = Math.ceil(((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.projektai) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.offsetPagination) === null || _c === void 0 ? void 0 : _c.total) / perPage) || 0;
    const items = data === null || data === void 0 ? void 0 : data.projektai.edges.map(edge => edge.node);
    return {
        items,
        loading,
        total,
        fetchMore: fetchMoreItems,
    };
}
function ListItem({ title, uri, categories }) {
    return React.createElement(Link, { href: uri, key: uri, className: "ltg-list-item" },
        React.createElement("div", { className: "ltg-list-item-title" }, title),
        categories.length > 0 && categories.map((category) => (React.createElement("small", { key: category.id, className: "ltg-list-item-categories text-muted" }, category.name))));
}
function useFilters(checked, hidden, show_empty) {
    const [lang] = useLang();
    const { data, loading } = useQuery(qAttributes, {
        client,
        variables: {
            include: checked || [],
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        }
    });
    if (loading)
        return {};
    const flat = data.terms.nodes;
    const labeled = flat.reduce((agr, curr) => {
        var _a;
        const prevAttributes = !!agr[curr.taxonomyEnumValue] ? (_a = agr[curr.taxonomyEnumValue]) === null || _a === void 0 ? void 0 : _a.attributes : [];
        if (+curr.count === 0 && show_empty !== 'yes')
            return agr;
        if (hidden.length !== 0 && hidden.includes(curr.taxonomyEnumValue))
            return agr;
        return Object.assign(Object.assign({}, agr), { [curr.taxonomyEnumValue]: {
                label: curr.taxonomyLabel,
                attributes: [
                    ...prevAttributes,
                    curr
                ]
            } });
    }, {});
    return { filters: labeled || {}, attrData: data };
}
